import parent from '@js/dom/parent';

export const ORIGIN = '*';
export const PREFIX = 'credere';

export const TYPES = [
  'scroll',
  'load',
  'resize',
  'token',

  'customer:read',
  'customer:create',
  'customer:update',

  'public_simulator_setting:read',
  'public_simulator_setting:create',
  'public_simulator_setting:update',
  'public_simulator_setting:find',
  'public_simulator_setting:contact',
  'public_simulator_setting:action',

  'lead:create',
  'lead:update',

  'simulation:create',

  'simulation:read',
  'simulation:read:processing',
  'simulation:read:action',

  'proposal:create',
  'proposal:create:failure',
  'proposal_attempt:create',
  'proposal_attempt:update',

  'vehicle:read',
  'vehicle:create',
  'vehicle:update',
  'vehicle:import',
  'vehicle:list',
  'vehicle:find',
  'vehicle:showroom:action',

  'vehicle_model:read',
  'vehicle_model:create',
  'vehicle_model:update',
  'vehicle_model:list',

  'report:score:action',

  'bank_commission_rules:read',
  'bank_commission_rules:update',

  'bank_ranking:read',
  'bank_ranking:update',

  'public_simulator_distribution:read',
  'public_simulator_distribution:update',
  'public_simulator_distribution:action',

  'public_simulator_connection:update',

  'public_simulator_automation:read',
  'public_simulator_automation:create',
  'public_simulator_automation:update',
  'public_simulator_automation:delete',

  'public_simulator_conversation:filter',

  'store:read',

  'system_alert:read',
  'system_alert:create',
  'system_alert:update',

  'onboarding:subscription:action',
].reduce((reduced, type) => {
  reduced[type] = {
    prefixed: `${PREFIX}:${type}`,
    constant: type.replace(/:/g, '_').toUpperCase(),
  };

  return reduced;
}, {});

function message(type, payload = {}) {
  if (!TYPES[type]) {
    // eslint-disable-next-line no-console
    console.error(`MESSAGE TYPE ${type} NOT FOUND`);
  }

  parent().postMessage({
    type: TYPES[type].prefixed,
    payload,
  }, ORIGIN);
}

export default Object.keys(TYPES).reduce((reduced, type) => {
  reduced[TYPES[type].constant] = (payload) => message(type, payload);

  return reduced;
}, {});
